export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {createVNode} from 'intact';
import type {
    XMarkdownCodeBlockRenderContext,
    XMarkdownCodeBlockRenderers,
} from 'kpc';

interface Props {
    content: string
}

const CONTENT = `# 代码块接管示例

\`\`\`ts
export function greet(name: string) {
    return \`hello, \${name}\`;
}
\`\`\`

\`\`\`mermaid
flowchart TD
    A[默认 Mermaid] --> B[接管后改成业务卡片]
\`\`\``;

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            content: CONTENT,
        };
    }

    getCodeBlockRenderers(): XMarkdownCodeBlockRenderers {
        return {
            ts: (context: XMarkdownCodeBlockRenderContext) => createVNode(
                'section',
                {className: 'xmarkdown-demo-code-shell'},
                [
                    createVNode(
                        'div',
                        {className: 'xmarkdown-demo-code-shell-head'},
                        [
                            createVNode('span', null, 'TypeScript'),
                            createVNode('span', null, context.blockType),
                        ]
                    ),
                    createVNode(
                        'pre',
                        {className: 'xmarkdown-demo-code-shell-body'},
                        context.source
                    ),
                ]
            ),
            mermaid: (context: XMarkdownCodeBlockRenderContext) => createVNode(
                'section',
                {className: 'xmarkdown-demo-mermaid-placeholder'},
                [
                    createVNode(
                        'div',
                        {className: 'xmarkdown-demo-mermaid-placeholder-title'},
                        '这里由业务接管 Mermaid'
                    ),
                    createVNode('code', null, context.source),
                ]
            ),
        };
    }
}